import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useUrlTemplate from '~/composables/useUrlTemplate';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useARIndicator } from '~/composables/useARIndicator';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useRawImages from './useRawImages';
import buildCarouselImages from './buildCarouselImages';
import { useProductType } from '~/composables/useProductType';

export default function useProcessImages() {
  const { productUrlTemplate } = useUrlTemplate();
  const { productData } = useProduct();
  const { memberProduct } = storeToRefs(useConsolidatedMemberStore());
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const { isConsolidatedPage } = useProductType();

  const videoId = computed(() => {
    if (isShopTheSetExpEnabled || isConsolidatedPage) {
      return memberProduct.value?.imagery?.videoId || productData?.imagery?.videoId || '';
    }
    return productData?.imagery.videoId || '';
  });

  const imageIndicator = useARIndicator(videoId);
  const { indicatorIndex, imageIndicatorEnabled, vtoEligibleExperiment } = imageIndicator;

  const imagesRaw = useRawImages();
  const images = computed(() => imagesRaw?.value?.filter(Boolean));

  const imageIndicatorSnapshot = computed(() => ({
    imageIndicatorEnabled: imageIndicator.imageIndicatorEnabled.value,
    indicatorIndex: imageIndicator.indicatorIndex.value,
    marxentUrlForMobile: imageIndicator.marxentUrlForMobile.value,
    vtoEligibleExperiment: imageIndicator.vtoEligibleExperiment.value,
  }));

  const carousel = computed(() => buildCarouselImages(images.value, videoId.value, imageIndicatorSnapshot.value, productUrlTemplate));

  function pauseVideo() {
    if (videoId.value) {
      const videoPlayer = window?.videojs?.players[`video_${videoId.value}`];
      if (videoPlayer) {
        setTimeout(() => {
          videoPlayer.pause();
        }, 0);
      }
    }
  }

  return {
    carouselImages: computed(() => carousel.value.carouselImages),
    primaryImageData: computed(() => carousel.value.primaryImageData),
    videoIndex: computed(() => carousel.value.videoIndex),
    videoId,
    vtoEligibleExperiment,
    indicatorIndex,
    imageIndicatorEnabled: imageIndicatorEnabled.value,
    pauseVideo,
  };
}
